import React, { SetStateAction } from "react";
import styles from "./Login.module.scss";
export default function Login({
  setInfo,
  onClickLogin,
}: {
  setInfo: React.Dispatch<SetStateAction<{ email: string; password: string }>>;
  onClickLogin: () => void;
}) {
  return (
    <section className={styles.container}>
      <input type="email" className="single-input-box" />
      <input type="password" className="single-input-box" />
      <button className="red-large-button">Login</button>
    </section>
  );
}
